import { queryOptions, useQuery } from '@tanstack/react-query';

import { abandonedCheckoutsApi } from '../api/abandoned-checkouts-api';

import { abandonedCheckoutKeys } from './abandoned-checkout-keys';

export function abandonedCheckoutQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: abandonedCheckoutKeys.detail(storeId, id),
    queryFn: () => abandonedCheckoutsApi.get(storeId, id),
  });
}

export function useAbandonedCheckout(storeId: string, id: string) {
  return useQuery(abandonedCheckoutQueryOptions(storeId, id));
}
